@use 'sass:map';
@use 'ui/styles/core-tokens' as core;

.overlay {
  background-color: rgba(9, 30, 66, 0.3);
  bottom: 0;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 52;
}

.sidebarCollapsed {
  animation-duration: 0.5s;
  background-color: map.get(core.$colors, simpleWhite);
  box-sizing: border-box;
  height: 100vh;
  position: absolute;
  right: 0;
  display: flex;
  flex-direction: column;

  &__s {
    width: 33vw;
    animation-name: slidein_s;
  }

  &__m {
    width: 50vw;
    animation-name: slidein_m;
  }

  &__l {
    width: 65vw;
    animation-name: slidein_l;
  }

  @keyframes slidein_s {
    from {
      width: 5vw;
    }

    to {
      width: 33vw;
    }
  }

  @keyframes slidein_m {
    from {
      width: 5vw;
    }

    to {
      width: 50vw;
    }
  }

  @keyframes slidein_l {
    from {
      width: 5vw;
    }

    to {
      width: 65vw;
    }
  }

  @media screen and (max-width: core.$mobileL) {
    width: 100vw;
  }

  .header {
    align-items: center;
    background-color: map.get(core.$colors, simpleWhite);
    display: flex;
    gap: 16px;
    padding: 16px 24px;
  }

  .content {
    flex-grow: 1;
    padding: 0 24px;
    overflow: auto;
  }

  .footer {
    border-top: 1px solid map.get(core.$colors, iconHover);
    display: flex;
    justify-content: space-between;
    padding: 16px 24px;
    width: auto;
  }
}
